import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, NgZone } from '@angular/core';

import { ToastType } from '@d-constants';
import { ToastService } from '@d-services';
import { AuditService } from '@d-services/wms/audit.service';

export class InternalErrorHandler implements ErrorHandler {
  toastService = inject(ToastService);
  zone = inject(NgZone);

  handleError(e: any) {
    if (e.status === 401) {
      try {
        localStorage.clear();

        window.location.reload();
      } catch (error) {}

      return;
    }

    this.zone.run(() => {
      if (e instanceof HttpErrorResponse) {
        var errors = JSON.parse(e.error);
        this.toastService.addSingle({
          type: ToastType.ERROR,
          message:
            (errors.messages && errors.messages[0].content) ||
            (errors.Messages && errors.Messages[0].Content) ||
            'Something went wrong, please try again later or contact System Admin for support',
        });
      }
      if (e instanceof TypeError) {
        console.error(e);
      }
    });
  }
}
